import {
  FileIcon,
  DownloadIcon,
} from "../../../../../components/ui-icons/upload";
import Loading from "../../../../../components/Loading";
import { formatBytes } from "../../../../../helpers/formatBytes";
import { useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";
import moment from "moment";
import { s3cloudUrl, strapiAPIUrl, typesListName } from "src/api/config";

type Props = {
  templates: any;
  statusTemplates: string;
};

const downLoadHandle = (e: any, url: string, name: string) => {
  e.preventDefault();
  fetch(url, {
    credentials: "include",
  })
    .then((response) => response.blob())
    .then((blob) => {
      const printFile = new File([blob], name, {
        type: blob.type,
        lastModified: moment().unix(),
      });
      let reader = new FileReader();
      reader.readAsDataURL(printFile);
      reader.onload = function () {
        const src = reader.result;
        const linkDownLoad: HTMLAnchorElement = document.createElement("a");
        linkDownLoad.setAttribute("download", printFile.name);
        // @ts-ignore
        linkDownLoad.setAttribute("href", src);
        linkDownLoad.style.display = "none";
        document.body.appendChild(linkDownLoad);
        linkDownLoad.click();
        document.body.removeChild(linkDownLoad);
      };
    });
};

function Step_1(props: Props) {
  const { templates, statusTemplates } = props;
  const types: any = useAppSelector((state) =>
    selectItems(state, typesListName)
  );
  console.log("templates: ", templates);
  return (
    <div className="step_1 md:min-w-[975px]">
      <span className="text-7.5 leading-[38px] font-bold text-black block mb-8">
        Шаблон документа
      </span>
      <span className="text-[16px] leading-[22px] font-medium text-black block mb-5">
        Скачайте шаблон и заполните документ
      </span>
      {statusTemplates === "LOADING" && <Loading />}
      {statusTemplates === "SUCCESS" && (
        <div className="px-4 sm:px-6 lg:px-8 mb-10">
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 shadow-custom">
              <div className="inline-block md:min-w-[975px] py-[20px] align-middle px-[25px] rounded-lg ">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        Шаблон
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Тип документа
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Дата обновления
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {templates.map((template: any, idx: number) => (
                      <tr key={template.ID}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                          <a
                            onClick={(e) =>
                              downLoadHandle(
                                e,
                                `${(template.File.url &&
                                  template.File.url.indexOf(s3cloudUrl) !==
                                  -1 &&
                                  template.File.url.replace(
                                    s3cloudUrl,
                                    strapiAPIUrl
                                  )) ||
                                `${strapiAPIUrl}${template.File.url}`
                                }`,
                                template.File.name
                              )
                            }
                            href="#"
                            className="flex flex-row justify-between gap-3 px-4 py-2 rounded-lg cursor-pointer upload bg-sp-gray box-border"
                          >
                            <div className="flex flex-col grow">
                              <div className="flex flex-row gap-x-2.5">
                                <div className="flex flex-col items-center justify-center">
                                  <FileIcon />
                                </div>
                                <div className="flex flex-col">
                                  {template.File.name} (
                                  {formatBytes(Number(template.File.size), 2)})
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col items-center justify-center download-icon">
                              <DownloadIcon />
                            </div>
                          </a>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {types.filter(
                            (type: any) =>
                              type.ID === template.TemplateType.get_lookupId()
                          ).length > 0 &&
                            types.filter(
                              (type: any) =>
                                type.ID === template.TemplateType.get_lookupId()
                            )[0]["Title"]}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {moment(template.TemplateDate).format("DD.MM.YYYY")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Step_1;
